import i from '~/i18n'

export const validator = (insertionOrder: InsertionOrder | null): boolean =>
  Boolean(insertionOrder?.checking_account_id)

export const labels = {
  title: i.t('rm:campaign.insertionOrder.block.title'),
  description: {
    pending: i.t('rm:campaign.insertionOrder.block.description'),
    done: (insertionOrder: InsertionOrder) => insertionOrder.name
  }
}
